import React from 'react';
import { View } from 'react-native';

import Entry from 'app/src/styles/mobileTable';
import { Link } from 'app/src/utils/routing';

const MobileRow = ({ entry, columns }) => {
  const actionColumn = columns[columns.length - 1];

  return (
    <Entry.Container>
      <Link to={`/dealers/${entry.id}`}>
        <Entry.Title>
          {entry.name}
        </Entry.Title>
      </Link>
      <Entry.Text>
        {entry.licenses.map(license => license.licenseString).join(', ')}
        {entry.city && ` - ${entry.city}`}
      </Entry.Text>
      {entry.userNickname && (
        <Entry.Text>
          Nickname: {entry.userNickname}
        </Entry.Text>
      )}
      {actionColumn.content({ entry })}
    </Entry.Container>
  );
};

export default MobileRow;
